export default "<p>jumbotron works!</p>\n";